import { clsx } from "clsx";
import { Product } from "@repo/apis/browse-search-v2";
import { RecommendationProduct } from "@repo/apis/recommendations";
import * as ProductTile from "@repo/ui/product-tile";
import { TYPOGRAPHY_BODY3_SENTENCE } from "@/theme/topshop/typography/typography-constants";

type ColoursBadgeProduct = Product | RecommendationProduct | null | undefined;

type ColoursBadgeProps = {
  product: ColoursBadgeProduct;
  className?: string;
};

const isProduct = (product: ColoursBadgeProduct): product is Product => {
  return (
    product !== null && product !== undefined && "facetGroupings" in product
  );
};

export const ProductTileColoursBadge = ({
  product,
  className,
}: ColoursBadgeProps) => {
  const hasColours = (() => {
    if (isProduct(product)) {
      return product.facetGroupings?.length;
    }

    return false;
  })();

  return hasColours ? (
    <ProductTile.Badge
      text="Colours"
      className={clsx(TYPOGRAPHY_BODY3_SENTENCE, className)}
      icon="+"
    />
  ) : null;
};
